<template>
  <div class="bg-beige1 px-4 py-5">
    <p class="mb-3 flex items-start gap-x-2 text-sm leading-relaxed text-black2">
      <BellRing aria-hidden="true" class="mt-[3px] size-4 shrink-0 text-gold1" />
      <span>No available dates? Get an email when a spot opens up.</span>
    </p>
    <AtomsSecondaryButton class="h-[48px] w-full" font-mode="en" :data-testid="props.buttonTestId" :on-click="props.onClick">
      <span class="inline-flex items-center gap-x-2">
        <Mail aria-hidden="true" class="size-4" />
        Get availability alerts
      </span>
    </AtomsSecondaryButton>
  </div>
</template>

<script lang="ts" setup>
import { BellRing, Mail } from '@lucide/vue';

import AtomsSecondaryButton from '@/components/atoms/SecondaryButton/SecondaryButton.vue';

interface Props {
  buttonTestId: string;
  onClick: () => void;
}

const props = defineProps<Props>();
</script>
